import React, { useState } from 'react';
import SelectDomainModal from './select_domain/SelectDomainModal';
import { Box, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import useCreateCasinoController from '../../../hooks/site/casino/useCreateCasinoController';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store';
import CusInput from '../../material-ui/CusInput';
import CusLabelSelect from '../../material-ui/CusLabelSelect';
import CusButton from '../../material-ui/CusButton';
import CusTooltip from '../../material-ui/CusTooltip';
import LangAndLink from './lang_and_link/LangAndLink';
import SelectGroup from '../SelectGroup';

export default function CasinoInfoContent({ onSaveClick }) {
  const { t } = useTranslation();
  const currenciesAll = useAppSelector((state) => state.user.info.currency);
  const [openDomain, setOpenDomain] = useState(false);

  const currencyOptions = Object.keys(currenciesAll).map((el) => ({ value: el, label: el }));

  const {
    domains,
    selectDomain,
    languages,
    defaultLanguage,
    languageFields,
    casinoName,
    selectGroupId,
    selectCurrencies,
    btnDisabled,
    changeLanguages,
    setDefaultLanguage,
    saveDomains,
    setCasinoName,
    setSelectGroupId,
    setSelectCurrencies,
    saveCasino
  } = useCreateCasinoController({ onSaveClick });

  const gridSize = 12;

  return (
    <>
      <Stack display={'flex'} direction={'column'} gap={2}>
        <Grid container spacing={1}>
          <Grid size={gridSize}>
            <CusInput
              label={'Casino name'}
              maxLength={100}
              value={casinoName}
              onChange={(e) => setCasinoName(e.target.value)}
            />
          </Grid>
          <Grid size={gridSize}>
            <SelectGroup
              selectGroupId={selectGroupId}
              setSelectGroupId={setSelectGroupId}
              isSelectNode={false}
            />
          </Grid>
          <Grid size={gridSize}>
            <Box>
              <CusLabelSelect
                label={'Currencies'}
                options={currencyOptions}
                multi
                value={selectCurrencies}
                onChange={(val) => setSelectCurrencies(val)}
              />
            </Box>
          </Grid>

          <Grid size={gridSize}>
            <Stack display={'flex'} direction="row" gap={0.5} alignItems={'center'}>
              <Typography>{t('Domain')}</Typography>
              <Typography fontWeight={600} fontSize={16} component="span" minHeight={20}>
                {domains.find((el) => el.default)?.name}
              </Typography>

              <CusButton
                fullWidth
                text={selectDomain ? 'Change' : 'Select'}
                variant="outlined"
                onClick={() => setOpenDomain(true)}
                sx={{ minWidth: 150 }}
              />
            </Stack>
          </Grid>
          <Grid size={12} mt={2}>
            <Box gap={1}>
              <Stack display={'flex'} flexDirection={'row'} gap={1}>
                <Typography>{t('Languages ​​and links for casinos')}</Typography>
                <CusTooltip
                  text={
                    "If links in a specific language are not filled in, then the site/bot will display links from the tab where the 'Default Language' is enabled."
                  }
                />
              </Stack>
              <LangAndLink
                languages={languages}
                defaultLanguage={defaultLanguage}
                languageFields={languageFields}
                setDefaultLanguage={setDefaultLanguage}
                changeLanguages={changeLanguages}
              />
              <CusButton
                sx={{ mt: 2 }}
                text="Save"
                variant="contained"
                onClick={saveCasino}
                disabled={btnDisabled}
              />
            </Box>
          </Grid>
        </Grid>
      </Stack>

      <SelectDomainModal
        open={openDomain}
        domains={domains}
        onClose={() => setOpenDomain(false)}
        saveDomains={saveDomains}
      />
    </>
  );
}
